<template>
  <div class="cashier">
    <div class="cashier-top">
      <div class="cashier-top-header">
        <div class="cashier-top-title"><i></i> 收银台</div>
      </div>
    </div>
    <div class="cashier-main">
      <div class="cashier-main-container">
        <div class="cashier-main-container-header">
          <div class="order-img">
            <img src="@/assets/imgs/orderImg.png" alt="" />
          </div>
          <div class="order-title">
            <h3>订单提交成功，应付金额：<span>{{price}}</span></h3>
            <h5>
              <p>服务项目：{{productTitle}}</p>
              <p>支付编号：TM124356765433245</p>
            </h5>
          </div>
        </div>
        <div class="paymentType">
          <div class="paymentType-title">
            <i></i> 请选择支付方式
            <span class="el-icon-warning-outline"
              >&nbsp;&nbsp;付款账户位公司账户，则可为付款的公司账户开局发票；如果是个人账户，则只能为付款人或申请人开局发票，请选择合适的付款账户。</span
            >
          </div>
          <div class="paymentType-tabs">
            <el-tabs type="card">
              <el-tab-pane>
                <span slot="label"
                  ><p><img src="@/assets/imgs/zhifubao-2.png" alt="" /></p>
                  支付宝</span
                >
                <Alipay />
              </el-tab-pane>
              <el-tab-pane>
                <span slot="label"
                  ><p><img src="@/assets/imgs/weixin.png" alt="" /></p>
                  微信</span
                >
                <Wechat />
              </el-tab-pane>
              <el-tab-pane>
                <span slot="label"
                  ><p><img src="@/assets/imgs/yinhangka.png" alt="" /></p>
                  银行卡</span
                >
                <Bankcard />
              </el-tab-pane>
              <el-tab-pane>
                <span slot="label"
                  ><p><img src="@/assets/imgs/tarendaifu.png" alt="" /></p>
                  他人代付</span
                >
                <Paymentothers />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Alipay from "./alipay";
import Wechat from "./wechat";
import Bankcard from "./bankcard";
import Paymentothers from "./paymentothers";
export default {
  components: {
    Alipay,
    Wechat,
    Bankcard,
    Paymentothers
  },
  data(){
    return{
      productTitle:'',
      price:''
    }
  },
  created(){
    this.productTitle = this.$route.query.name
    this.price = localStorage.getItem('zzzdPrice')
  }
};
</script>

<style lang="scss">
.cashier {
  width: 100%;
  .cashier-top {
    width: 100%;
    height: 40px;
    background: #fff;
    box-shadow: 0px 4px 4px 0px rgba(25, 29, 56, 0.1);
    .cashier-top-header {
      max-width: 1240px;
      height: 100%;
      padding: 0 20px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      .cashier-top-title {
        width: 100%;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: rgba(51, 51, 51, 1);
        i {
          display: inline-block;
          width: 3px;
          height: 16px;
          background: #3071fe;
          border-radius: 100px;
          margin-right: 8px;
        }
      }
    }
  }
  .cashier-main {
    width: 100%;
    padding: 30px 0 20px 0;
    background: #f5f5f7;
    .cashier-main-container {
      max-width: 1240px;
      padding: 0 20px;
      margin: 0 auto;
    }
  }
}
.cashier-main-container-header {
  width: 100%;
  padding: 21px;
  background: #fff;
  margin-bottom: 16px;
  box-shadow: 0px 2px 4px 0px rgba(207, 207, 207, 0.5);
  display: flex;
  .order-img {
    width: 51px;
    height: 51px;
    margin-right: 18px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .order-title {
    h3 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      margin-bottom: 10px;
      span {
        font-size: 18px;
        color: #ff5b00;
      }
    }
    h5 {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 17px;
      display: flex;
      p {
        margin-right: 25px;
      }
    }
  }
}
.paymentType {
  width: 100%;
  min-height: 364px;
  background: #fff;
  padding: 0 18px;
  box-shadow: 0px 2px 4px 0px rgba(207, 207, 207, 0.5);
  .paymentType-title {
    width: 100%;
    line-height: 16px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
    padding: 24px 0 15px 0;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #dadada;
    i {
      display: inline-block;
      width: 3px;
      height: 16px;
      margin-right: 6px;
      background: #3071fe;
      border-radius: 100px;
    }
    span {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(48, 113, 254, 1);
      line-height: 17px;
      margin-left: 20px;
    }
  }
  .paymentType-tabs {
    width: 100%;
    padding: 20px 0 0;
    .el-tabs {
      .el-tabs__item {
        span {
          p {
            width: 18px;
            height: 18px;
            margin-right: 10px;
            float: left;
            display: flex;
            align-items: center;
            margin-top: 11px;
            img {
              width: 18px;
            }
          }
        }
      }
    }
  }
}
</style>
